module.exports = __webpack_public_path__ + "img/welcome-dark.641edcf6.svg";